// extracted by mini-css-extract-plugin
module.exports = {"seperator":"page_seperator__s_avm","banner":"page_banner__FsnWP"};